(function(){
  if(window.__pmEnvio)return;window.__pmEnvio=1;
  var META=4900,total=null,count=0,tm;
  var css=document.createElement('style');
  css.textContent='.cart-drawer .progress_bar_main{display:none!important}.product__info-container .price__badge-sale,.product__info-wrapper .price__badge-sale{display:none!important}.pm-eb{margin:10px 16px 6px;padding:10px 12px;border-radius:8px;background:#e8f0f7;font-size:13px;line-height:1.4;color:#2b2b2b}.pm-eb b{color:#0e324c}.pm-eb-track{height:6px;border-radius:4px;background:#c9d8e6;margin-top:8px;overflow:hidden}.pm-eb-fill{height:100%;background:#0e324c;border-radius:4px;transition:width .3s}.pm-eb.ok{background:#e8f6ee}.pm-eb.ok b{color:#1e7e45}.pm-eb.ok .pm-eb-track{background:#cdebd9}.pm-eb.ok .pm-eb-fill{background:#1e7e45}#main-cart-footer .pm-eb{margin:0 0 14px}';
  document.head.appendChild(css);
  function fmt(c){return 'S/ '+(c/100).toFixed(2);}
  function html(){
    if(count<1)return '';
    if(total>=META)return '<div class="pm-eb ok">Tu pedido tiene <b>envío gratis</b><div class="pm-eb-track"><div class="pm-eb-fill" style="width:100%"></div></div></div>';
    var p=Math.max(4,Math.round(total*100/META));
    return '<div class="pm-eb">Te faltan <b>'+fmt(META-total)+'</b> para tener <b>envío gratis</b> (compras desde S/ 49)<div class="pm-eb-track"><div class="pm-eb-fill" style="width:'+p+'%"></div></div></div>';
  }
  function targets(){
    var t=[],h=document.querySelector('#CartDrawer .drawer__header'),cf=document.querySelector('#main-cart-footer .cart__blocks');
    if(h)t.push([h,'afterend']);if(cf)t.push([cf,'afterbegin']);return t;
  }
  function wrapOf(t){var w=t[1]==='afterend'?t[0].nextElementSibling:t[0].firstElementChild;return (w&&w.classList&&w.classList.contains('pm-eb-wrap'))?w:null;}
  function missing(){return targets().some(function(t){return !wrapOf(t);});}
  function paint(){
    targets().forEach(function(t){
      var w=wrapOf(t);
      if(!w){w=document.createElement('div');w.className='pm-eb-wrap';t[0].insertAdjacentElement(t[1],w);}
      if(total===null)return;
      var k=count+'-'+total;
      if(w.getAttribute('data-k')!==k){w.innerHTML=html();w.setAttribute('data-k',k);}
    });
  }
  function load(){
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){total=c.total_price;count=c.item_count;paint();}).catch(function(){});
  }
  function soon(){clearTimeout(tm);tm=setTimeout(load,300);}
  function init(){
    load();
    if(typeof subscribe==='function'&&typeof PUB_SUB_EVENTS!=='undefined'){try{subscribe(PUB_SUB_EVENTS.cartUpdate,soon);}catch(e){}}
    new MutationObserver(function(){if(missing()){paint();soon();}}).observe(document.body,{childList:true,subtree:true});
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
